import i18next from "i18next"

export default function formatNumber(number : number) {
    return new Intl.NumberFormat('fr').format(Math.round(number))
}

